module.exports = __webpack_public_path__ + "svg/icon-leaf-3-bg.svg";